interface RocketIconProps {
  width?: number
  height?: number
  color?: string
  active?: boolean
}

const RocketIcon = ({ width, height, color, active }: RocketIconProps): JSX.Element => {
  const strokeColor = color ? color : active ? '#2482D8' : '#636F7E'
  return (
    <svg
      width={width ? width : '20'}
      height={height ? height : '20'}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.83333 10.8333H4.16667C3.5 10.8333 3.08333 10.1667 3.41667 9.58333L5.25 6.25C5.41667 5.91667 5.75 5.75 6.08333 5.75H10M5.83333 10.8333L9.16667 14.1667M5.83333 10.8333L10 5.75M9.16667 14.1667V16.0833C9.16667 16.75 9.83333 17.1667 10.4167 16.8333L13.75 14.75C14.0833 14.5833 14.25 14.25 14.25 13.9167V10.4167M9.16667 14.1667L14.25 10.4167M14.25 10.4167C16.5 8.33333 18.0833 6.08333 18.3333 3.08333C18.375 2.58333 17.9583 2.16667 17.4583 2.20833C14.4583 2.45833 12.2083 4 10 5.75M4.16667 17.5H3.33333C2.875 17.5 2.5 17.125 2.5 16.6667V15.8333C2.5 14.9167 3.25 14.1667 4.16667 14.1667C5.08333 14.1667 5.83333 14.9167 5.83333 15.8333C5.83333 16.75 5.08333 17.5 4.16667 17.5Z"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default RocketIcon
